<template>
    <div class="nav-bar">
        <div class="left-wrap">
            <div class="logo" @click="toIndexPage">
                <img src="../../assets/mall_logo.png" alt="云仓商城">
            </div>
            <ul class="nav">
                <li class="item" :class="{act: curPath.indexOf('/dealer/index') >= 0}"><a class="link" href="javascript:;" @click="toIndexPage">首页</a></li>
                <li class="item down" :class="{act: curPath.indexOf('/dealer/order') >= 0}">
                    <span class="link no">我的订单</span> <i class="ic-down el-icon-arrow-down"></i>
                    <div class="dropdown">
                        <ul class="dropdown-inner">
                            <li class="dropdown-item">
                                <a class="dropdown-link" href="javascript:;" @click="toOrderpage(1)">锁仓订单</a>
                            </li>
                            <li class="dropdown-item">
                                <a class="dropdown-link" href="javascript:;" @click="toOrderpage(2)">下单订单</a>
                            </li>
                            <li class="dropdown-item">
                                <a class="dropdown-link" href="javascript:;" @click="toOrderpage(3)">清算订单</a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
           
        </div>
        <div class="right-wrap">
            <div class="nav-search-box">
                <i class="ic-search" @click="toSearch"></i>
                <input class="search-input" @keyup.enter="toSearch" type="text" v-model.trim="searchWord" placeholder="ID/商品名称/款号">
            </div>
            <div class="user-info" @click="toLogin">
                <div class="avatar">
                    <img src="../../assets/ic_user_center.png" alt="">
                </div>
                <div class="dropdown" v-if="account">
                    <ul class="dropdown-inner">
                        <li class="dropdown-item">
                            <span class="dropdown-link" @click="toDataPanel">数据面板</span>
                        </li>
                        <li class="dropdown-item">
                            <span class="dropdown-link" @click="toSettingPage">个人设置</span>
                        </li>
                        <li class="dropdown-item">
                            <span class="dropdown-link" @click="toQuit">退出登录</span>
                        </li>
                    </ul>
                </div>
                <div class="welcome-word" v-if="account">
                    <span class="text">您好！{{account}}</span>
                </div>
                <button v-if="!account" type="button" class="btn-login">登录</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getCurrentFormatTime } from '../../utils/tools'
export default {
    data() {
        return {
            curTime: '',
            timer: null,
            searchWord: '',
        }
    },
    computed: {
        ...mapGetters(['userType', 'account', 'userId', 'merchantId']),
        curPath() {
            return this.$route.path
        },
    },
    created() {
        this.showTime();
    },
    methods: {
        toIndexPage() {
            this.$router.push('/dealer/index?mid=' + this.merchantId)
        },
        toOrderpage(type) {
            if (!this.userId) {
                this.$message.warning('请先登录')
                this.toLogin()
                return
            }
            if (type == 1) {
                this.$router.push('/dealer/order/list-lock')
            }
            if (type == 2) {
                this.$router.push('/dealer/order/list-take')
            }
            if (type == 3) {
                this.$router.push('/dealer/order/list-clear')
            }
        },
        showTime() {
            this.curTime = getCurrentFormatTime()
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                this.curTime = getCurrentFormatTime()
            }, 1000);
        },
        switchUserType() {
            let type = this.userType == 'supplier' ? 'dealer' : 'supplier'
            let tipText = this.userType == 'supplier' ? '您将跳转到销售商页面，是否继续？' : '您将跳转到供应商页面，是否继续？'
            this.$confirm(tipText, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.push('/' + type)
            })
        },
        toDataPanel() {
            this.$router.push('/dealer/data-panel')
        },
        toSettingPage() {
            if (this.userType == 'supplier') {
                this.$router.push('/supplier/setting')
            }
            if (this.userType == 'dealer') {
                this.$router.push('/dealer/setting')
            }
        },
        toQuit() {
            this.$store.dispatch('logOut', 1)
        },
        toLogin() {
            if (!this.userId) {
                this.$router.push('/login?redirect=' + this.$route.fullPath)
            }
        },
        toSearch() {
            if (this.curPath.indexOf('/dealer/goods/list') == 0) {
                this.$bus.$emit('dw-search-word', this.searchWord)
            } else {
                this.$router.push('/dealer/goods/list?mid='+ this.merchantId + '&search=' + this.searchWord)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.nav-bar {
    position: fixed;
    top: 0; 
    left: 0;
    width: 100%;
    height: 64px;
    padding: 0 40px 0 64px;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 0px 0px rgba(239,239,239,1);
    min-width: 1000px;
    z-index: 10;
    box-sizing: border-box;
}
.dropdown {
    position: absolute;
    left: 0;
    top: 36px;
    width: 130px;
    background: rgba($color: #0E0E0E, $alpha: 0.64);
    box-sizing: border-box;
    transition: 0.2s;
    height: 0;
    overflow: hidden;
    opacity: 0;
    transform: scaleY(0);
    transform-origin: 50% 0;
    border-radius: 2px;
}
.dropdown-inner {
    padding: 24px 0 0 24px;
    list-style: none;
}
.dropdown-item {
    margin-bottom: 18px;
}
.dropdown-link {
    display: block;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 20px;
    text-decoration: none;
    &:hover {
        opacity: 0.8;
    }
}
.left-wrap {
    float: left;
    height: 36px;
    padding-top: 14px;
    .logo {
        float: left;
        img { width: 142px; height: 36px; display: block;}
    }
    .nav {
        padding: 0 0 0 64px;
        height: 36px;
        display: flex;
        .item {
            position: relative;
            display: flex;
            & + .item {
                margin-left: 50px
            }
            &::after {
                content: ' ';
                position: absolute;
                bottom: 2px;
                left: 50%;
                width: 0px;
                height: 2px;
                background: #FF0E0E;
                border-radius: 2px;
                transition: .3s;
            }
            &.down::after {
                margin-left: -10px;
            }
            &.act::after, &:hover::after {
                width: 28px;
                margin-left: -14px;
            }
            &.down.act::after, &.down:hover::after {
                margin-left: -24px;
            }
            
            .link {
                display: inline-block;
                text-decoration: none;
                font-size: 16px;
                color: #000000;
                line-height: 34px;
                &.no {
                    cursor: default;
                }
            }
            .ic-down {
                margin-left: 4px;
                margin-top: 12px;
                color: #000000;
            }
            &:hover .dropdown {
                opacity: 1;
                height: auto;
                overflow: visible;
                transform: scaleY(1);
            }
            
        }
    }
}
.right-wrap {
    float: right;
    height: 40px;
    padding-top: 14px;
    .nav-search-box {
        float: left;
        margin-top: 6px;
        height: 26px;
        width: 234px;
        border-bottom: 1px solid #333333;
        margin-right: 30px;
        display: flex;
        justify-content: space-between;
        .ic-search {width: 26px; height: 26px; 
            background: url(../../assets/ic_search.png) no-repeat center center/20px 20px;
            cursor: pointer;
        }
        .search-input {
            outline: 0;
            color: #333;
            width: 190px; height: 26px; border: none; margin: 0; 
            &::placeholder {color: rgba(0, 0, 0, 0.25);}
        }
    }
    .user-info {
        float: left;
        height: 40px;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
        .welcome-word {
            float: left;
            margin-left: 8px;
            .text {
                font-size: 14px;
                color: #030C1D;
                line-height: 40px;
            }
        }
        .avatar {
            float: left;
            
            width: 22px; height: 22px;
            padding-top: 8px;
            overflow: hidden;
            img {width: 100%;}
        }
        .dropdown {
            top: 40px;
        }
        &:hover .dropdown {
            opacity: 1;
            height: auto;
            overflow: visible;
            transform: scaleY(1);
        }
        .btn-login {
            cursor: pointer;
            outline: none;
            float: left;
            margin-top: 4px;
            margin-left: 24px;
            width: 72px;
            height: 32px;
            border: 1px solid #FF0E0E;
            font-size: 14px;
            color: #FF0E0E;
            background-color: #fff;
            &:hover, &:active {
                opacity: 0.8;
            }
        }
    }
}

</style>
